// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconLogoFacebook = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M23 12c0-6.075-4.925-11-11-11S1 5.925 1 12c0 5.49 4.022 10.041 9.281 10.866V15.18H7.488V12h2.793V9.576c0-2.756 1.643-4.28 4.156-4.28 1.202 0 2.462.216 2.462.216V8.22H15.51c-1.367 0-1.793.848-1.793 1.717V12h3.05l-.487 3.18h-2.563v7.687C18.978 22.041 23 17.49 23 12" />
  );
export default SvgIconLogoFacebook;
